import Vue from "vue";
import VueRouter from "vue-router";

const InnerPage = () => import("../components/InnerPage.vue");
const Container = () => import("../components/Container.vue");
Vue.use(VueRouter);

const routes = [
  {
    path: "/innerpage",
    component: InnerPage
  },
  {
    path: "/",
    component: Container
  }
];

const router = new VueRouter({
  // mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
